module.exports = __webpack_public_path__ + "assets/img/tj_head_back_left.fd2073dd.png";